import React from "react";
import Alert from "../../../components/Alert";
import Button from "../../../components/Button";
import Input from "../../../components/Inputs";
import Modal from "../../../components/Modal";
import {
  actionResetPutAlertasPlanoDeAcao,
  actionPutAlertasPlanoDeAcao,
} from "../../../features/alertas/plano-de-acao/slices";
import { actionGetAlertasAbertos } from "../../../features/alertas/slices";
import transformDate from "../../../helpers/transform-date";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { toast } from "sonner";

const Actions = ({ close, confirm }) => {
  const { putAlertasReconhecer } = useAppSelector((state) => state);
  const {
    status,
    data: dataPlanoDeAcao,
    error,
  } = useAppSelector((state) => state.getAlertaPlanoDeAcao);

  return (
    <nav className="actions">
      <Button size="sm" variant="secondary" onClick={close}>
        Fechar
      </Button>
      {dataPlanoDeAcao && dataPlanoDeAcao.dataInseridoPlanoAcao ? (
        <>
          <Button
            size="sm"
            variant="primary"
            onClick={confirm}
            disabled
            loading={putAlertasReconhecer.status === "loading"}
          >
            Confirmado
          </Button>
        </>
      ) : (
        <>
          <Button
            size="sm"
            variant="primary"
            onClick={confirm}
            loading={putAlertasReconhecer.status === "loading"}
          >
            Confirmar
          </Button>
        </>
      )}
    </nav>
  );
};

const ModalPlanoDeAcao = ({ close, data }) => {
  const dispatch = useAppDispatch();
  const [state, setState] = React.useState({
    id: "",
    causa: "",
    planoAcao: "",
    previsao: "",
  });

  const { putAlertasPlanoDeAcao } = useAppSelector((state) => state);

  const { id, dataEvento, dataNormalizacao, descricao } = data;

  const confirm = async () => {
    if (!state.causa || !state.planoAcao || !state.previsao) {
      return toast.error("Preencha todos os campos");
    }
    await dispatch(actionPutAlertasPlanoDeAcao(state));
    await dispatch(actionGetAlertasAbertos({ idLoja: data.idLoja }));
    await dispatch(actionResetPutAlertasPlanoDeAcao());
    close();
  };

  const handleClose = () => {
    dispatch(actionGetAlertasAbertos({ idLoja: data.idLoja }));
    close();
  };

  const handleChange = ({
    target: { name, value },
  }: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setState((prev) => ({ ...prev, id, [name]: value }));

  const {
    status,
    data: dataPlanoDeAcao,
    error,
  } = useAppSelector((state) => state.getAlertaPlanoDeAcao);

  React.useEffect(() => {
    if (dataPlanoDeAcao?.dataInseridoPlanoAcao) {
      setState({
        id: data.id,
        causa: dataPlanoDeAcao.causa || "",
        planoAcao: dataPlanoDeAcao.planoAcao || "",
        previsao: dataPlanoDeAcao.dataPrevisaoPlanoAcao,
      });
    } else {
      setState({
        id: data.id,
        causa: "",
        planoAcao: "",
        previsao: "",
      });
    }
  }, [dataPlanoDeAcao, data.id]);

  return (
    <Modal
      size="md"
      overflow={true}
      header={
        <>
          <h3 className="heading--sm">Plano de ação - Alerta {id}</h3>
          <p>
            <strong>Data evento: </strong>
            {transformDate(dataEvento, true)}{" "}
            {dataNormalizacao && (
              <>
                <strong>Data normalização: </strong>
                {transformDate(dataNormalizacao, true)}
              </>
            )}
          </p>
          <p className="paragraph mb-10">
            <strong>Descrição:</strong> {descricao}{" "}
          </p>
        </>
      }
      actions={<Actions close={handleClose} confirm={confirm} />}
    >
      {dataPlanoDeAcao && dataPlanoDeAcao.dataInseridoPlanoAcao != null ? (
        <>
          <Input
            type="textarea"
            placeholder="Informe a causa"
            label="Causa"
            size="md"
            name="causa"
            disabled
            value={state.causa}
            onChange={handleChange}
            rows={3}
            style={{ minHeight: 80 }}
            maxLength={300}
          />
          <Input
            type="textarea"
            placeholder="Descreva o plano de ação"
            label="Plano de ação"
            size="md"
            disabled
            value={dataPlanoDeAcao.planoAcao}
            name="planoAcao"
            onChange={handleChange}
            rows={3}
            style={{ minHeight: 80 }}
            maxLength={300}
          />
          <Input
            type="text"
            label="Previsão"
            size="md"
            disabled
            value={transformDate(dataPlanoDeAcao.dataPrevisaoPlanoAcao, true)}
            name="previsao"
            onChange={handleChange}
          />
        </>
      ) : (
        <>
          <Input
            type="textarea"
            placeholder="Informe a causa"
            label="Causa"
            size="md"
            name="causa"
            value={state.causa}
            onChange={handleChange}
            rows={3}
            style={{ minHeight: 80 }}
            maxLength={300}
          />
          <Input
            type="textarea"
            placeholder="Descreva o plano de ação"
            label="Plano de ação"
            size="md"
            name="planoAcao"
            value={state.planoAcao}
            onChange={handleChange}
            rows={3}
            style={{ minHeight: 80 }}
            maxLength={300}
          />
          <Input
            type="datetime-local"
            label="Previsão"
            size="md"
            name="previsao"
            value={state.previsao}
            onChange={handleChange}
          />
        </>
      )}
    </Modal>
  );
};

export default ModalPlanoDeAcao;
